enum AccentColour {
    MAGENTA,
    AQUAMARINE
}

export default AccentColour